<template>
    <div class="form-input-group">
        <div class="form-input-group--small">
            <slot name="small"></slot>
        </div>

        <div class="form-input-group--big">
            <slot name="big"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        name: String,
        help: String,
    },
}
</script>
